import { AppConstants } from '@ltvco/refresh-lib/ctx';
import { Avatar, Text, Grid, Button, Link } from '@ltvco/refresh-lib/theme';
import { useSession } from '@ltvco/refresh-lib/v1';
import { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { SidenavContainer } from 'components/sidenav/SidenavContainer';
import { goToLogin } from 'utils/goToLogin';

import warning from '../images/img_warning.svg';

export function ErrorPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    data: { supportEmail },
  } = useContext(AppConstants);
  const { isAuthenticated } = useSession().session;

  function goToDashboard() {
    navigate('/dashboard');
  }

  const Container = isAuthenticated ? SidenavContainer : Grid;
  const navigateFunction = isAuthenticated
    ? goToDashboard
    : () => goToLogin('https://www.peoplesmart.com');
  const navigateTo = isAuthenticated ? 'dashboard' : 'login';
  const errorStatusCode = location?.state?.meta?.status || '';

  return (
    <Container>
      <Grid container spacing={3} textAlign={'center'} marginTop={8}>
        <Grid size={{ xs: 12 }}>
          <Avatar
            src={warning}
            alt="error"
            sx={{ width: 95, height: 80, margin: 'auto' }}
            variant="square"
          />
          <Text variant="h2" color={'primary'} fontSize={52} marginTop={2.5}>
            {errorStatusCode} Whoops!
          </Text>
          <Text variant="h3" fontSize={24} marginTop={2.5}>
            Looks like something went wrong.
          </Text>
          <Text margin={'auto'}>
            We apologize for the inconvenience; please contact{' '}
            <Link
              href={`mailto:${supportEmail}?subject=${errorStatusCode} Whoops Error`}
            >
              {supportEmail}
            </Link>{' '}
            if this problem persists and tell them you received a
            {errorStatusCode ? '' : 'n'} {errorStatusCode} error.
          </Text>
          <Button
            variant="contained"
            sx={{ marginTop: 2.5 }}
            onClick={navigateFunction}
          >
            Go to {navigateTo}
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
}
